import {

  CORE_LOAD_ALLFBS_REQUEST,
  CORE_LOAD_ALLFBS_SUCCESS,

  CORE_LOAD_FBSINFO_REQUEST,
  CORE_LOAD_FBSINFO_SUCCESS,

  CORE_LOAD_ALL_CATEGORY_REQUEST,
  CORE_LOAD_ALL_CATEGORY_SUCCESS,

  CORE_SEARCH_FBS_REQUEST,
  CORE_SEARCH_FBS_SUCCESS,

} from '../../../types'

const initialState = []
export default {
  fbs: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALLFBS_REQUEST:
      case CORE_SEARCH_FBS_REQUEST:
        return initialState
      case CORE_LOAD_ALLFBS_SUCCESS:
      case CORE_SEARCH_FBS_SUCCESS:
        return action.payload
      default:
        return state
    }
  },

  fbsInfo: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_FBSINFO_REQUEST:
        return {}
      case CORE_LOAD_FBSINFO_SUCCESS:
        return action.payload
      default:
        return state
    }
  },

  fbCategory: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALL_CATEGORY_REQUEST:
        return initialState

      case CORE_LOAD_ALL_CATEGORY_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
}


// WEBPACK FOOTER //
// ./src/features/settings/fbs/reducer.js